var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.loading,"z-index":"20"}},[_c('div',{staticClass:"d-flex flex-column align-center justify-center"},[_c('loader'),_vm._t("default",function(){return [_vm._v(" Operation in progress ")]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }